import { MessageSquare, FileText, HelpCircle } from "lucide-react"
import { Card, CardHeader, CardContent, CardTitle } from "../ui/card.tsx"
import { Button } from "../ui/button.tsx"

export const QuickHelpCards = ({ onChatClick, isChatOpen }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <Card className={`bg-white hover:shadow-md transition-shadow ${isChatOpen ? 'ring-2 ring-purple-500' : ''}`}>
        <CardHeader>
          <div className="flex items-center space-x-2">
            <div className={`p-2 rounded-full transition-colors ${isChatOpen ? 'bg-purple-500' : 'bg-purple-100'}`}>
              <MessageSquare className={`h-6 w-6 ${isChatOpen ? 'text-white' : 'text-purple-500'}`} />
            </div>
            <CardTitle>{isChatOpen ? 'Chat Active' : 'Contact Support'}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-4">Get in touch with our support team for personalized assistance</p>
          <Button 
            variant={isChatOpen ? "outline" : "purple"} 
            className={`w-full ${isChatOpen ? 'border-purple-500 text-purple-500' : ''}`} 
            onClick={onChatClick}
          >
            {isChatOpen ? 'Close Chat' : 'Contact Us'}
          </Button>
        </CardContent>
      </Card>

      <Card className="bg-white hover:shadow-md transition-shadow">
        <CardHeader>
          <div className="flex items-center space-x-2">
            <div className="p-2 bg-purple-100 rounded-full">
              <FileText className="h-6 w-6 text-purple-500" />
            </div>
            <CardTitle>Submit a Ticket</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-4">Create a new support ticket to report an issue or request help</p>
          <Button variant="purple" className="w-full">
            New Ticket
          </Button>
        </CardContent>
      </Card>

      <Card className="bg-white hover:shadow-md transition-shadow">
        <CardHeader>
          <div className="flex items-center space-x-2">
            <div className="p-2 bg-purple-100 rounded-full">
              <HelpCircle className="h-6 w-6 text-purple-500" />
            </div>
            <CardTitle>Knowledge Base</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-4">Browse our comprehensive knowledge base for self-service support</p>
          <Button variant="purple" className="w-full">
            Browse Articles
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
